import Base from './base';

export default class Hebcal extends Base {
  newsletter(params) {
    return this.apiClient.get(`hebcal`, params);
  }
}
